<div
  class="lua-color-item"
  [class.selected]="isSelected"
  (click)="onClick()"
>
  <div class="color-item"></div>
</div>
